function generateRandomString(length: number = 128): string {
  const array = new Uint8Array(length);
  crypto.getRandomValues(array);
  return Array.from(array, (byte) => String.fromCharCode(byte)).join("");
}

function base64URLEncode(array: string | Uint8Array): string {
  const str =
    typeof array === "string"
      ? array
      : String.fromCharCode(...array);
  return btoa(str)
    .replace(/=/g, "")
    .replace(/\+/g, "-")
    .replace(/\//g, "_");
}

export function createCodeVerifier(): string {
  return base64URLEncode(generateRandomString(128));
}

export async function createCodeChallenge(codeVerifier: string): Promise<string> {
  const encoder = new TextEncoder();
  const data = encoder.encode(codeVerifier);
  const digest = await crypto.subtle.digest("SHA-256", data);
  return base64URLEncode(new Uint8Array(digest));
}

export function generateState(): string {
  return base64URLEncode(generateRandomString(32));
}
